import { useEffect, useState } from 'react';
import { finApi } from '../../api/finance.js';
import { useAuth } from '../../contexts/AuthContext.jsx';

export default function Customers() {
  const { can } = useAuth();
  const [items, setItems] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const canCreate = can('customer', 'create');

  function refresh() { finApi.customers().then((d) => setItems(d?.items || [])); }
  useEffect(refresh, []);

  async function submit(e) {
    e.preventDefault();
    const fd = new FormData(e.currentTarget);
    await finApi.createCustomer({
      name: fd.get('name'),
      taxId: fd.get('taxId') || null,
      creditLimit: Number(fd.get('creditLimit') || 0),
      contact: { email: fd.get('contactEmail') || null, phone: fd.get('contactPhone') || null },
    });
    e.currentTarget.reset();
    setShowForm(false);
    refresh();
  }

  return (
    <section>
      <header className="page-header">
        <h1>Customers</h1>
        {canCreate && <button className="btn primary" onClick={() => setShowForm((s) => !s)}>{showForm ? 'Close' : '+ New Customer'}</button>}
      </header>

      {showForm && (
        <form onSubmit={submit} className="card form-card grid-form">
          <label>Name<input name="name" required /></label>
          <label>Tax ID<input name="taxId" /></label>
          <label>Credit Limit<input name="creditLimit" type="number" step="0.01" defaultValue={0} /></label>
          <label>Contact Email<input name="contactEmail" type="email" /></label>
          <label>Contact Phone<input name="contactPhone" /></label>
          <div className="full actions"><button className="btn primary" type="submit">Create</button></div>
        </form>
      )}

      <div className="card">
        <table className="data-table">
          <thead><tr><th>Name</th><th>Tax ID</th><th>Credit Limit</th><th>Contact</th><th>Status</th></tr></thead>
          <tbody>
            {items.map((c) => {
              const ct = typeof c.contact === 'string' ? JSON.parse(c.contact) : c.contact || {};
              return (
                <tr key={c.id}>
                  <td><strong>{c.name}</strong></td>
                  <td className="muted">{c.tax_id || '—'}</td>
                  <td>{Number(c.credit_limit).toFixed(2)}</td>
                  <td className="muted">{ct.email || ct.phone || '—'}</td>
                  <td><span className={`chip status-${c.is_active ? 'active' : 'cancelled'}`}>{c.is_active ? 'active' : 'inactive'}</span></td>
                </tr>
              );
            })}
            {items.length === 0 && <tr><td colSpan={5} className="muted">No customers yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
